export const SET_CONTEXT_MENU = 'Editor/ContextMenu/SET_CONTEXT_MENU';
